import{SET_STORE_FINDER_SEARCH_RADIUS}from"../constants";/**
 * Creates the dispatched SET_USER_SEARCH_POSTAL_CODE action object.
 * @param {number} radius The radius.
 * @returns {Object}
 */var setStoreFinderSearchRadius=function setStoreFinderSearchRadius(radius){return{type:SET_STORE_FINDER_SEARCH_RADIUS,radius:radius};};export default setStoreFinderSearchRadius;